module.exports = __webpack_public_path__ + "static/media/carta_86.b59f42b5.jpg";